import { localize } from '@/core/gambits';
import { getTodayDateKey } from '@/views/main/sparks/utils/intent-visibility';
import { addCalendarDaysToDateKey, parseSparkProposalInstant } from '@/views/main/sparks/utils/proposal-time';
import { format } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';

const parseDateKeyToLocalDate = (dateKey: string): Date => {
  const [year, month, day] = dateKey.split('-').map(Number);
  return new Date(year, month - 1, day);
};

export const formatSuccessWhenLabel = (
  date: string,
  timeSpanStart: string | null | undefined,
  timeZone: string | undefined,
  now: Date = new Date(),
): string => {
  const resolvedTimeZone = timeZone || 'UTC';
  const todayKey = getTodayDateKey(now, resolvedTimeZone);
  const tomorrowKey = addCalendarDaysToDateKey(todayKey, resolvedTimeZone, 1);
  const dayLabel =
    date === todayKey
      ? localize('spark.success.today')
      : date === tomorrowKey
        ? localize('spark.success.tomorrow')
        : format(parseDateKeyToLocalDate(date), 'EEEE');

  if (!timeSpanStart) {
    return dayLabel;
  }

  const timeLabel = formatInTimeZone(
    parseSparkProposalInstant(timeSpanStart, resolvedTimeZone),
    resolvedTimeZone,
    'HH:mm',
  );
  return `${dayLabel} · ${timeLabel}`;
};
